import { ContractDocumentRow } from "../contractDocuments/ContractDocuments.types";
import { useDeleteContractDocumentHook } from "./DeleteContractDocumentDialog.hooks";
import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import DeleteBlockedDialog from "@common/components/deleteBlockedDialog/DeleteBlockedDialog";
import { useTranslation } from "@localization/useTranslation";
import { contractDocumentBlockerTranslationKeys } from "./DeleteContractDocumentDialog.types";

export interface IDeleteContractDocumentDialogProps {
    onCloseDialog: () => void;
    onDeleted: () => void;
    selectedDocument: ContractDocumentRow;
    contractId: string | undefined;
}

export function DeleteContractDocumentDialog(props: IDeleteContractDocumentDialogProps) {
    const { translateString } = useTranslation();
    const { deleteDocumentClick, inProgess, blockedDeletion } = useDeleteContractDocumentHook(props);

    if (blockedDeletion) {
        return (
            <DeleteBlockedDialog
                header={translateString("contractDocumentCannotBeDeletedHeader")}
                description={translateString("contractDocumentCannotBeDeletedDescription", { name: props.selectedDocument.name })}
                blockers={blockedDeletion.blockers}
                blockerTranslationKeys={contractDocumentBlockerTranslationKeys}
                onDialogClose={props.onCloseDialog}
            />
        );
    }

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.selectedDocument!.name}
            onDialogClose={props.onCloseDialog}
            onOkClick={() => deleteDocumentClick(props.selectedDocument!.documentId)}
            inProgress={inProgess}
        />
    );
}
